module.exports = __webpack_public_path__ + "img/load_balancer-1.0275f8e0.webp";